/**
 * Node customizado para pausar bot (Human Takeover)
 * Pausa a automação para permitir atendimento humano
 * 
 * RELEASE: 1.0.0 - 2025-01-26 - Novo node para sistema de pausa de bot
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { HandMetal, Clock } from 'lucide-react';
import { FlowNodeData } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node de pausar bot
 */
export function PauseBotNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  
  // Callbacks injetados via FlowCanvas
  const onEdit = (nodeData as any).onEdit;
  const onDuplicate = (nodeData as any).onDuplicate;
  const onDelete = (nodeData as any).onDelete;
  const onTestFromHere = (nodeData as any).onTestFromHere;
  
  // Extrai configuração
  const pauseType = nodeData.config?.pause_type || 'indefinite';
  const pauseDuration = nodeData.config?.pause_duration;
  
  // Define descrição baseado no tipo
  const getDescription = () => {
    if (pauseType === 'timed' && pauseDuration) {
      return `Pausa por ${pauseDuration} min`;
    }
    return 'Pausa indefinida';
  };

  return (
    <div className="bg-card rounded-lg shadow-lg border-2 border-amber-500 min-w-[200px] max-w-[240px]">
      {/* Toolbar flutuante */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType={nodeData.type}
        onEdit={onEdit}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onTestFromHere={onTestFromHere}
        isVisible={selected}
      />
      
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-amber-500 !w-3 !h-3"
      />
      
      <div className="p-3">
        <div className="flex items-center gap-2 mb-2">
          <div className="bg-amber-500/10 text-amber-600 p-2 rounded">
            <HandMetal className="h-4 w-4" />
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm text-foreground">
              {nodeData.config?.nickname || 'Pausar Bot'}
            </div>
          </div>
          {pauseType === 'timed' && (
            <Clock className="h-3 w-3 text-muted-foreground" />
          )}
        </div>
        
        <div className="text-xs text-muted-foreground bg-muted/50 rounded p-2">
          {getDescription()}
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-amber-500 !w-3 !h-3"
      />
    </div>
  );
}
